import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { UserCard } from '@/entities/user/user-card/UserCard'
import type { UserDto } from '@/shared/api/user'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute(
  '/_auth/applications/limitations/limitation/$limitationId/common/user/$userId'
)({
  component: RouteComponent,
})

export const mockUser: UserDto = {
  id: 'e1de6bfa-ae96-41aa-b0ea-ca856937681d',
  firstName: 'Админов',
  lastName: 'Админ',
  middleName: 'Админович',
  email: 'evgenia.vik+1@mail.ru',
  userType: {
    id: '689bd5ca-ba1a-42c9-b369-9a83f0f4a9aa',
    code: 'EMPLOYEE',
    name: 'Сотрудник',
    active: true,
  },
  customer: {
    id: '1',
    firstName: 'John Doe',
    email: 'john.doe@example.com',
    iin: '1234567890',
    birthDate: '2000-01-01',
    gender: 'male',
    active: true,
    lastName: 'Doe',
    middleName: 'Doe',
    mobilePhone: '1234567890',
  },
  company: {
    id: '7cee9a67-5e33-44c1-8004-c849d13847d1',
    bin: '990440003072',
    code: 'SCHOOL',
    nameKk: '90 мектеп',
    nameRu: '90 школа',
    kato: '750000000',
    active: true,
    tenantId: 'c9d12a6c-5eed-4c94-aba7-32e7cb13ebe0',
  },
  roles: [
    {
      id: '966ab1c3-5f91-4413-b4f4-16072046f165',
      code: 'ADMIN_SCHOOL',
      nameRu: 'Администратор школы',
      nameKk: 'Администратор школы',
      tenantId: 'c9d12a6c-5eed-4c94-aba7-32e7cb13ebe0',
    },
    {
      id: '966ab1c3-5f91-4413-b4f4-16072046f165',
      code: 'ADMIN_SCHOOL',
      nameRu: 'Администратор школы',
      nameKk: 'Администратор школы',
      tenantId: 'c9d12a6c-5eed-4c94-aba7-32e7cb13ebe0',
    },
  ],
  isLocked: false,
  lockReasonCode: '',
  lockReasonName: '',
  passwordAttempts: 0,
  isProtected: false,
  createdAt: '2025-10-16T20:02:00.985492Z',
  updatedAt: '2025-10-16T20:02:00.985492Z',
  invitationSent: false,
}

function RouteComponent() {
  const { t } = useTranslation()
  const { isOpen, close } = useRouteOffcanvas('../..')
  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка пользователя АПК')}>
      <UserCard user={mockUser} />
    </Offcanvas>
  )
}
